(() => {
  if (window.solsticeCompositionIdeasBound) return;
  window.solsticeCompositionIdeasBound = true;
  // Run before the shared generic composer link handler, which opens an empty link.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-composition-ideas-edit]');
    if (!link) return;
    const hash = link.dataset.compositionHash;
    if (!hash || !new URLSearchParams(hash).has('m')) return;
    event.preventDefault();
    event.stopPropagation();
    history.replaceState(history.state, '', location.pathname + location.search + '#' + hash);
    if (window.isEarAppMounted) window.dispatchEvent(new HashChangeEvent('hashchange'));
    window.dispatchEvent(new CustomEvent('vue-toggle-app', { detail: true }));
  }, true);
})();
